export const decodeOtherLanguage = function (strToDecode) {
    return decodeURIComponent(escape(window.atob(strToDecode)));
};


// WEBPACK FOOTER //
// ./src/util/helpers/Helpers.js